<template>

  <div class="index">
    <div>
      <div class="region">
        <div class="region-item">
          <div class="region-item-title">收件地址</div>
          <div class="region-item-line">
            <div class="region-item-line-title">地址</div>
            <div class="region-item-line-content" @click="popupCity = true">
              <span style="font-size: 14px;">{{ region }}</span>
              <img src="../../../assets/icon/right.png" alt="">
            </div>
            <van-popup v-model="popupCity" position="bottom">
              <van-area :area-list="areaList" @confirm="confirmArea" @cancel="popupCity = false" />
            </van-popup>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">详细地址</div>
            <normal-input key="address" keyname="address" :rules="defaultRules" v-model="addressData.address" clearable
              :isShowIcon='false' placeholder="请输入详细地址" label="" type="" :isAutoFocus="true"
              update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">收件人</div>
            <normal-input key="name" keyname="name" v-model="addressData.name" clearable :isShowIcon='false'
              placeholder="请输入收件人名称" label="" type="" :rules="nameRules" :isAutoFocus="true"
              update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">手机号</div>
            <normal-input key="mobile" keyname="mobile" v-model="addressData.mobile" clearable :isShowIcon='false'
              placeholder="请输入联系电话" label="" type="" :rules="mobileRules" :isAutoFocus="true"
              update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">设为默认地址</div>
            <div class="region-item-line-content">
              <span>默认地址</span>
              <van-switch active-color="#FAC859" v-model="addressData.default" size="24px" />
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="index-btn">
      <button @click="editAddress" v-if="id" :style="disabledValue ? '' : 'background: #f8dda1;'"
        :disabled='!disabledValue'>提交信息</button>
      <button @click="addAddress" v-else :style="disabledValue ? '' : 'background: #f8dda1;'"
        :disabled='!disabledValue'>确认添加</button>
    </div>



    <!-- <div class="edit-container">
      <div class="input-item">
        <span>省市区</span>
        <span @click="popupCity = true">{{ region }}</span>
        <van-popup v-model="popupCity" position="bottom">
          <van-area :area-list="areaList" @confirm="confirmArea" @cancel="popupCity = false" />
        </van-popup>
      </div>
      <div class="input-item">
        <span>详细地址</span>
        <input placeholder="请输入详细地址" v-model="addressData.address">
      </div>
      <div class="footer">
        <button v-if="id" class="footer-left" @click="toDelete">删除</button>
        <button v-else class="footer-left" @click="toCancel">取消</button>
        <button v-if="id" class="footer-right" @click="editAddress">确认更改地址</button>
        <button v-else class="footer-right" @click="addAddress">确认新增地址</button>
      </div>
    </div> -->


  </div>


</template>

<script>
// import store from '../../../store'
import area from '@/util/area'
import Config from '@/config/config'
import Vue from 'vue'
import qs from 'qs'
import { Toast } from 'vant'
import { Area, Popup } from 'vant'
import { Switch } from 'vant'
import { Dialog } from 'vant'
import { mapGetters } from 'vuex'
import NormalInput from '@/components/normalInput.vue'

Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Toast)
Vue.use(Popup).use(Area)

export default {
  name: 'AddressEdit',
  data() {
    return {
      area: area,
      id: '',
      addressData: {
      },
      popupCity: false,
      region: '请选择所在地区',
      areaList: area,
      nameRules: [
        { type: 'isSpecialChar', message: '不能包含特殊字符和表情，且长度不能超过32位' },
        { type: 'isNameLength', message: '长度必须保证在1~32位', min: 1, max: 32 },
      ],
      mobileRules: [
        { type: 'isPhoneNumber', message: '手机号格式不对' },
      ],
      defaultRules: [{ type: 'isEmpty', message: '请输入内容，不能为空' }],
      verify: {
        address: false,
        name: false,
        mobile: false
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    disabledValue() {
      return (this.verify.address && this.verify.name && this.verify.mobile && this.verify.mobile && this.region != '请选择所在地区')
    }
  },
  components: {
    NormalInput
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getData()
      console.log(this.$router, '=====')
    }
  },
  methods: {
    getData() {
      var that = this
      // var params = { id: this.$route.params.id }
      console.log(this.$route.params.id)
      this.axios.get('/user/address/' + this.$route.params.id + '/').then(function (res) {
        that.addressData = res.data
        that.addressData.default = Boolean(res.data.default)
        that.region = that.addressData.province + ' ' + that.addressData.city + ' ' + that.addressData.district
        console.log(that.addressData)
      }).catch(function (error) {
        console.log(error)
      })
    },
    onChange() {
      console.log(e)
    },
    fruitValueChange(e, keyname) {
      this.verify[keyname] = e
    },

    addAddress() {
      if (this.region == '请选择所在地区') {
        return Toast('请选择所在地区')
      }
      if (!this.addressData.name) {
        return Toast('请输入收件人')
      }
      if (!this.addressData.mobile) {
        return Toast('请输入联系电话')
      }
      if (!this.addressData.address) {
        return Toast('请输入详细地址')
      }
      var that = this
      var params = {
        name: this.addressData.name,
        mobile: this.addressData.mobile,
        province: this.addressData.province,
        city: this.addressData.city,
        district: this.addressData.district,
        address: this.addressData.address,
        default: Number(this.addressData.default) || 0,
        province_code: this.addressData.province_code,
        city_code: this.addressData.city_code,
        district_code: this.addressData.district_code
      }
      this.axios.post('/user/address/', qs.stringify(params)).then(function (res) {
        console.log(res)
        if (!res.code) {
          Toast('添加成功')
          // 创建地址后，同步地址到积分商城，保证积分商城有相同地址
          // 若用户未访问过积分商城，该同步无效
          const url = Config.creditStoreBackendUrl + '/user/address/'
          params.default = that.addressData.default
          params.code = that.userInfo.code
          that.axios.post(url, params, {
            headers: {
              'X-APP-ID': Config.creditStoreAppId,
              'X-USER-CODE': that.userInfo.openid
            }
          }).then(function () {
            that.$router.go(-1)
          }).catch(function () {
            that.$router.go(-1)
          })
        } else {
          Toast(res.data.message)
        }
      }).catch(function (error) {
        console.log(error)
        Toast('添加失败')
      })
    },

    editAddress(data) {
      if (this.region == '请选择所在地区') {
        return Toast('请选择所在地区')
      }
      if (!this.addressData.name) {
        return Toast('请输入收件人')
      }
      if (!this.addressData.mobile) {
        return Toast('请输入联系电话')
      }
      if (!this.addressData.address) {
        return Toast('请输入详细地址')
      }
      var that = this
      var params = {
        id: this.$route.params.id,
        name: this.addressData.name,
        mobile: this.addressData.mobile,
        province: this.addressData.province,
        city: this.addressData.city,
        district: this.addressData.district,
        address: this.addressData.address,
        default: Number(this.addressData.default),
        province_code: this.addressData.province_code,
        city_code: this.addressData.city_code,
        district_code: this.addressData.district_code
      }
      this.axios.put('/user/address/' + this.$route.params.id + '/', qs.stringify(params)).then(function (res) {
        console.log(res)
        if (!res.code) {
          Toast('修改成功')
          that.$router.go(-1)
        } else {
          Toast(res.data.message)
        }
      }).catch(function (error) {
        console.log(error)
        Toast('修改失败')
      })
    },

    confirmArea(data) {
      console.log(data)
      this.popupCity = false
      this.region = data[0].name + ' ' + data[1].name + ' ' + data[2].name
      this.addressData.province = data[0].name
      this.addressData.city = data[1].name
      this.addressData.district = data[2].name
      this.addressData.province_code = data[0].code
      this.addressData.city_code = data[1].code
      this.addressData.district_code = data[2].code
    },

    toDelete() {
      if (this.addressData.default === true) {
        Toast('默认地址不能删除')
      } else {
        Dialog.confirm({
          title: '确认删除吗'
        }).then(() => {
          var that = this
          this.axios.delete('/user/address/' + this.$route.params.id + '/').then(function (res) {
            that.$router.push({ name: 'Address' })
          }).catch(function (error) {
            console.log(error)
          })
        }).catch(() => {
          // on cancel
        })
      }
    },

    toCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  background: #F6F8FA;
  height: 233px;
  background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);


  .region {
    // position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 100px;
    &-item {
      background: #ffffff;
      border-radius: 16px;
      padding: 15px;
      margin: 15px;
      gap: 15px;


      &-title {
        font-size: 16px;
        font-weight: bold;
        color: #111827;
      }

      &-line {
        display: flex;
        flex-direction: column;
        gap: 12px;

        &.row {
          flex-direction: row;
          justify-content: space-between;
        }

        &-title {
          margin-top: 16px;
          font-size: 14px;
          font-weight: bold;
          color: #111827;
        }

        &-tips {
          font-size: 12px;
          font-weight: 400;
          color: #A0AEC0;
        }

        &-content {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 16px;
          background: #f6f8fa;
          border-radius: 12px;

          span {
            font-size: 14px;
            color: #8b97a6;
            font-weight: 400;
          }

          input {
            flex: 1;
            font-size: 14px;
          }

          img {
            width: 16px;
            height: 16px;
            transform: rotate(90deg);
          }
        }

        &-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          background: #0caf60;
          box-shadow: 0px 4px 8px 0px rgba(0, 88, 45, 0.2);
          border-radius: 12px;
        }
      }
    }



  }

  &-btn {
    position: fixed;
    bottom: 35px;
    left: 0;
    right: 0;
    padding-bottom: 20px;

    /* 兼容 iOS >= 11.2 */
    margin-left: 15px;
    margin-right: 15px;

    button {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      background: #FAC859;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      border-style: none
    }
  }


}

/deep/ .login-input {
  font-size: 14px !important;
  color: #111827 !important;
  background: #F6F8FA !important;
  border-radius: 12px;
  z-index: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border: none !important;

  input {
    background-color: transparent !important;
  }
}




.edit-container {
  .input-item {
    height: 44px;
    padding: 0 10px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }

    input {
      width: 280px;
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      text-align: right;
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .footer-left {
      width: 175px;
      height: 45px;
      border-radius: 5px;
      border: 1px solid #dddddd;
      background-image: linear-gradient(180deg, #ffffff 0%, #f8f8f8 100%);
      color: #000000;
      font-size: 16px;
      font-weight: 400;
    }

    .footer-right {
      width: 175px;
      height: 45px;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/address/edit.vue